import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUserId } from "modules/auth/redux/selectors";
import {
  selectCurrentEventId,
  selectHasJoinedEvent,
} from "modules/event/selectors";
import {
  subscribeRoomInvite,
  unsubscribeRoomInvite,
} from "modules/room/roomInvitation.firebase";
import { useAcceptInviteToTable } from "modules/inviteToTable";

export const InviteTableListener = () => {
  const eventId = useSelector(selectCurrentEventId);
  const hasJoinedEvent = useSelector(selectHasJoinedEvent);
  const userId = useSelector(selectUserId);
  const { notifyUser } = useAcceptInviteToTable();

  useEffect(() => {
    if (!hasJoinedEvent || !eventId || !userId) {
      return undefined;
    }

    subscribeRoomInvite(eventId, userId, notifyUser); // getting users from different rooms, placing users in special rooms

    return () => {
      unsubscribeRoomInvite(eventId, userId);
    };
  }, [eventId, userId, notifyUser, hasJoinedEvent]);

  return null;
};
